import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Media } from '@/js/libs/ui/src/theme/Media';
import { usePuzzleNavigationContext } from '../../context';
import { usePathMatch } from '../../hooks';
import { NewBadge } from '../NewBadge';
import { TagContainer, Wrapper } from './styled';
const ItemSubLink = ({ title, exact, path, to, onClick, dataTestId, tag, isNew }) => {
    const match = usePathMatch({ path: path ?? to, exact });
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const { collapseMainNav } = usePuzzleNavigationContext();
    const handleCloseMenu = useCallbackRef(() => {
        if (to && isMobile) {
            collapseMainNav();
        }
    });
    return (_jsxs(Wrapper, { "$active": match, children: [isNew && _jsx(NewBadge, {}), to && (_jsxs(Link, { to: to, onClick: handleCloseMenu, "data-testid": dataTestId, children: [_jsx("span", { children: title }), tag && _jsx(TagContainer, { children: tag })] })), onClick && (_jsxs("span", { onClick: onClick, "data-testid": dataTestId, children: [_jsx("span", { children: title }), tag && _jsx(TagContainer, { children: tag })] }))] }));
};
export default memo(ItemSubLink);
